import { AdminButton } from './AdminButton'
import styles from './ViewState.module.css'

/**
 * Loading, empty, and error states for admin views.
 */
export function ViewState({ variant, message, onRetry }) {
  if (variant === 'loading') {
    return (
      <div className={styles.state} aria-live="polite">
        <div className={styles.spinner} />
        <p className={styles.message}>{message || 'Loading…'}</p>
      </div>
    )
  }

  if (variant === 'error') {
    return (
      <div className={styles.state} role="alert">
        <p className={styles.errorMessage}>{message || 'Something went wrong'}</p>
        {onRetry && (
          <AdminButton variant="secondary" onClick={onRetry}>
            Retry
          </AdminButton>
        )}
      </div>
    )
  }

  // empty
  return (
    <div className={styles.state}>
      <p className={styles.message}>{message || 'No data found'}</p>
    </div>
  )
}
